module.exports = "<iframe src=\"http://speciateai.com/snaps/graphs/graph_d3_v3.html\" height=\"1000px\" width=\"1000px\" frameBorder=\"0\"></iframe>"